<template>
  <div class="info" v-loading="loading">
    <back />

    <div class="s_wrapper">
      <el-input class="s_input" v-model="searchParams.nickName" placeholder="搜索用户名称" suffix-icon="el-icon-search"
        @change="handleSearch" clearable></el-input>
      <el-input class="s_input" v-model="searchParams.userCode" placeholder="搜索用户编号" suffix-icon="el-icon-search"
        @change="handleSearch" clearable></el-input>
      <el-input class="s_input" v-model="searchParams.phoneNum" placeholder="搜索电话号码" suffix-icon="el-icon-search"
        @change="handleSearch" clearable></el-input>
    </div>

    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="100">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="userCode" label="用户编号"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="nickName" label="用户名称"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="gender" label="用户性别">
          <template slot-scope="scope">
            <span v-if="scope.row.gender === 0">女</span>
            <span v-if="scope.row.gender === 1">男</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="phoneNum" label="电话号码">
          <template slot-scope="scope">
            <span>{{ scope.row.phoneNum || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="createdTime" label="购买时间"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="totalLesson" label="课时总数"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="watchLesson" label="完课课时数"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="watchLessonRate" label="完课率(%)"></el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      searchParams: {
        nickName: "",
        userCode: "",
        phoneNum: "",
        id: null,
        page: 1,
        pageSize: 10
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      pageSizeArr: [10, 20, 50],
      totalCount: 0,
      apiType: null // 1: selectUserBuyPage, 2: selectUserBuyPageLive
    }
  },
  created() {
    this.apiType = this.$route.query.type;
    this.searchParams.id = this.$route.query.id;
    this.fetchData();
  },
  methods: {
    // 统一数据获取方法
    fetchData() {
      this.loading = true;
      const api = this.apiType == 1
        ? this.$api.selectUserBuyPage
        : this.$api.selectUserBuyPageLive;

      this.$axios.post(api, {
        ...this.searchParams,
        page: this.currentPage,
        pageSize: this.pageSize
      }).then(res => {
        this.tableData = res.result.list || [];
        this.totalCount = res.result.totalCount || 0;
        this.loading = false;
      }).catch(err => {
        this.$message.error(err.desc);
        this.loading = false;
      });
    },

    // 处理搜索输入
    handleSearch() {
      this.currentPage = 1;
      this.fetchData();
    },

    // 切换每页显示的条数
    handleSizeChange(e) {
      this.pageSize = e;
      this.fetchData();
    },

    // 换页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.fetchData();
    }
  }
}
</script>

<style lang="scss" scoped>
/* 原有样式保持不变 */
</style>